import { createAsyncThunk } from "@reduxjs/toolkit";
import { addDoc, getFirestore, collection } from "firebase/firestore";

export const saveBooking = createAsyncThunk(
  "bookings/saveBooking",
  async (userDetails, { rejectWithValue }) => {
    try {
      console.log("Inside saveBooking:", userDetails);
      const db = getFirestore();
      const bookingsCollectionRef = collection(db, "bookings");
      const docRef = await addDoc(bookingsCollectionRef, userDetails);
      console.log("Document written with ID: ", docRef.id);
      return userDetails;
    } catch (error) {
      console.error("Error saving booking:", error);
      return rejectWithValue(error.message);
    }
  }
);
